import {WalletContext} from '#/contexts/wallet-provider';
import {useContext} from 'react';
import {isEqualLowerCase} from 'shareland-common';

export const useIsUserAccount = (targetAccount: string) => {
  const {
    accountResult: {address: account},
  } = useContext(WalletContext);
  return account && isEqualLowerCase(account, targetAccount);
};
